import Vue from 'vue';

// Crea una nueva instancia de Vue para usar como bus de eventos
const EventBus = new Vue();

// Exporta el bus de eventos para que esté disponible en toda la aplicación
export default EventBus;